export const Urls = "https://api-multiverse.taction.in/api/api/v1/";
